// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// #region RiskPlanItem
import { MarginTypes } from '../Instruments/MarginTypes';
import { ProductType } from '../Instruments/ProductType';
export class RiskPlanItem {
    constructor() {
        this.ProductType = ProductType.General;
        this.CalculateMarginType = null;
        this.MarginMode = null;
        this.UseSameCrossPriceForOpenClose = null;
        this.HedgedMarginCallSize = null;
        this.HedgedMarginCallCoeff = null;
        this.AllowOvernightTrading = null;
        this.AllowToWithdrawUnrealizedProfit = null;
        this.UseOvernightMargin = null;
        this.UseLongShortMargin = null;
        this.MarginCoeficientList = null;
        this.MarginCoefficient = null;
        this.UseOpenPriceInMargin = null;
        this.UseUnsettledProfitAndOpenProfitInMarginAvailable = null;
        this.UseUnsettledCashForStocksInMarginAvailable = null;
        this.IsShortable = null;
        this.MaxLot = null;
        this.MinLot = null;
        this.LotStep = null;
        this.IsCashTradingAllowed = false;
        this.MaxPositionQtyPerSymbol = null;
        this.MaxPositionValuePerSymbol = null;
        this.MaxPositionValuePerSymbolGroup = null;
        this.MaxPositionValuePerSuperGroup = null;
        this.PositionValueCurrencyId = null;
        this.UseUnsettledNegativeStockOperationInWA = null;
        this.UseUnsettledPositiveStockOperationInWA = null;
        this.UseUnsettledProfitInWA = null;
        this.IsPositionCloseOnly = null;
        this.CurrencyId = null; // #116496
        /// <summary>
        /// #82717 Use Usettled collateral in margin available calculation
        /// </summary>
        this.UseUnsettledCollateralInMA = null;
        /// <summary>
        /// #82717 Use Usettled collateral in Withdrawal available calculation
        /// </summary>
        this.UseUnsettledCollateralInWA = null;
        /// #98161
        this.UseSettledCashForStocksForOpenedPositionsInMA = null; // if checked, settled stock operations for opened positions will be added to Margin available
        this.UseSettledCollateralForOpenedPositionInMA = null; //  if checked, settled collateral operations for opened positions will be added to Margin available
        this.Leverages = []; // #111414->#112880->#112886
    }
    mergeWith(newItem) {
        this.ProductType = newItem.ProductType;
        this.Leverages = newItem.Leverages;
        if (newItem.CalculateMarginType !== null) {
            this.CalculateMarginType = newItem.CalculateMarginType;
        }
        if (newItem.MarginMode !== null) {
            this.MarginMode = newItem.MarginMode;
        }
        if (newItem.UseSameCrossPriceForOpenClose !== null) {
            this.UseSameCrossPriceForOpenClose = newItem.UseSameCrossPriceForOpenClose;
        }
        if (newItem.HedgedMarginCallSize !== null) {
            this.HedgedMarginCallSize = newItem.HedgedMarginCallSize;
        }
        if (newItem.HedgedMarginCallCoeff !== null) {
            this.HedgedMarginCallCoeff = newItem.HedgedMarginCallCoeff;
        }
        if (newItem.UseOvernightMargin !== null) {
            this.UseOvernightMargin = newItem.UseOvernightMargin;
        }
        if (newItem.AllowOvernightTrading !== null) {
            this.AllowOvernightTrading = newItem.AllowOvernightTrading;
        }
        if (newItem.AllowToWithdrawUnrealizedProfit !== null) {
            this.AllowToWithdrawUnrealizedProfit = newItem.AllowToWithdrawUnrealizedProfit;
        }
        if (newItem.UseLongShortMargin !== null) {
            this.UseLongShortMargin = newItem.UseLongShortMargin;
        }
        if (newItem.MarginCoefficient !== null) {
            this.MarginCoefficient = newItem.MarginCoefficient;
        }
        if (newItem.UseOpenPriceInMargin !== null) {
            this.UseOpenPriceInMargin = newItem.UseOpenPriceInMargin;
        }
        if (newItem.IsShortable !== null) {
            this.IsShortable = newItem.IsShortable;
        }
        if (newItem.MaxLot !== null) {
            this.MaxLot = newItem.MaxLot;
        }
        if (newItem.MinLot !== null) {
            this.MinLot = newItem.MinLot;
        }
        if (newItem.MaxPositionQtyPerSymbol !== null) {
            this.MaxPositionQtyPerSymbol = newItem.MaxPositionQtyPerSymbol;
        }
        if (newItem.MarginCoeficientList !== null) {
            this.MarginCoeficientList = newItem.MarginCoeficientList;
        }
        if (newItem.UseUnsettledProfitAndOpenProfitInMarginAvailable !== null) {
            this.UseUnsettledProfitAndOpenProfitInMarginAvailable =
                newItem.UseUnsettledProfitAndOpenProfitInMarginAvailable;
        }
        if (newItem.UseUnsettledCashForStocksInMarginAvailable !== null) {
            this.UseUnsettledCashForStocksInMarginAvailable = newItem.UseUnsettledCashForStocksInMarginAvailable;
        }
        if (newItem.UseUnsettledNegativeStockOperationInWA !== null) {
            this.UseUnsettledNegativeStockOperationInWA = newItem.UseUnsettledNegativeStockOperationInWA;
        }
        if (newItem.UseUnsettledPositiveStockOperationInWA !== null) {
            this.UseUnsettledPositiveStockOperationInWA = newItem.UseUnsettledPositiveStockOperationInWA;
        }
        if (newItem.UseUnsettledProfitInWA !== null) {
            this.UseUnsettledProfitInWA = newItem.UseUnsettledProfitInWA;
        }
        if (newItem.UseUnsettledCollateralInMA !== null) {
            this.UseUnsettledCollateralInMA = newItem.UseUnsettledCollateralInMA;
        }
        if (newItem.UseUnsettledCollateralInWA !== null) {
            this.UseUnsettledCollateralInWA = newItem.UseUnsettledCollateralInWA;
        }
        if (newItem.UseSettledCashForStocksForOpenedPositionsInMA !== null) {
            this.UseSettledCashForStocksForOpenedPositionsInMA = newItem.UseSettledCashForStocksForOpenedPositionsInMA;
        }
        if (newItem.UseSettledCollateralForOpenedPositionInMA !== null) {
            this.UseSettledCollateralForOpenedPositionInMA = newItem.UseSettledCollateralForOpenedPositionInMA;
        }
        if (newItem.IsPositionCloseOnly !== null) {
            this.IsPositionCloseOnly = newItem.IsPositionCloseOnly;
        }
        // if (newItem.CurrencyId !== null)
        this.CurrencyId = newItem.CurrencyId;
        if (newItem.MaxPositionValuePerSymbol !== null) {
            this.MaxPositionValuePerSymbol = newItem.MaxPositionValuePerSymbol;
        }
        if (newItem.MaxPositionValuePerSymbolGroup !== null) {
            this.MaxPositionValuePerSymbolGroup = newItem.MaxPositionValuePerSymbolGroup;
        }
        if (newItem.MaxPositionValuePerSuperGroup !== null) {
            this.MaxPositionValuePerSuperGroup = newItem.MaxPositionValuePerSuperGroup;
        }
        if (newItem.PositionValueCurrencyId !== null) {
            this.PositionValueCurrencyId = newItem.PositionValueCurrencyId;
        }
    }
    getCopy() {
        const copy = new RiskPlanItem();
        copy.mergeWith(this);
        return copy;
    }
    // Margin
    GetMarginCoeficientItem(tier) {
        var _a;
        let item = null;
        if (!tier)
            tier = 0;
        if ((_a = this.MarginCoeficientList) === null || _a === void 0 ? void 0 : _a[tier]) {
            item = this.MarginCoeficientList[tier];
        }
        return item;
    }
    GetWarnMargin(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_WARN_MARGINGSIZE : null;
        return value !== null ? value : 0;
    }
    GetInitMargin(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_INIT_MARGINGSIZE : null;
        return value !== null ? value : 0;
    }
    GetMaintMargin(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_HOLD_MARGINGSIZE : null;
        return value !== null ? value : 0;
    }
    // Overnight
    GetWarnMarginOvernight(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_WARN_MARGINGSIZE_OVERNIGHT : null;
        return value !== null ? value : 0;
    }
    GetInitMarginOvernight(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_INIT_MARGINGSIZE_OVERNIGHT : null;
        return value !== null ? value : 0;
    }
    GetMaintMarginOvernight(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_HOLD_MARGINGSIZE_OVERNIGHT : null;
        return value !== null ? value : 0;
    }
    // Short
    GetWarnMarginShort(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_WARN_MARGINGSIZE_SHORT : null;
        return value !== null ? value : 0;
    }
    GetInitMarginShort(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_INIT_MARGINGSIZE_SHORT : null;
        return value !== null ? value : 0;
    }
    GetMaintMarginShort(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_HOLD_MARGINGSIZE_SHORT : null;
        return value !== null ? value : 0;
    }
    // OvernightShort
    GetWarnMarginOvernightShort(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_WARN_MARGINGSIZE_OVERNIGHT_SHORT : null;
        return value !== null ? value : 0;
    }
    GetInitMarginOvernightShort(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_INIT_MARGINGSIZE_OVERNIGHT_SHORT : null;
        return value !== null ? value : 0;
    }
    GetMaintMarginOvernightShort(tier) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_HOLD_MARGINGSIZE_OVERNIGHT_SHORT : null;
        return value !== null ? value : 0;
    }
    // UseOvernight and UseLongShort
    GetUseOvernightMargin() {
        return this.UseOvernightMargin;
    }
    GetUseLongShortMargin() {
        return this.UseLongShortMargin;
    }
    // VarCoeff
    GetUseVarOnlyIntraday(tier = undefined) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_USE_VAR_ONLY_INTRADAY : null;
        return value !== null ? value : 0;
    }
    GetVarCoeff(tier = undefined) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_VAR_COEFF : null;
        return value !== null ? value : 0;
    }
    GetVarCoeffApplying(tier = undefined) {
        const marginCoefficientItem = this.GetMarginCoeficientItem(tier);
        const value = marginCoefficientItem ? marginCoefficientItem.Futures_VAR_COEFF_APPLYING : null;
        return value !== null ? value : 0;
    }
    // GetType
    GetMarginType() {
        return this.CalculateMarginType;
    }
    // Leverages: #111414->#112880->#112886
    IsPriceBasedMultipleCoefMarginType() {
        return this.CalculateMarginType === MarginTypes.PRICE_BASED_MULTIPLE_COEF;
    }
    IsNoneMarginType() {
        return this.CalculateMarginType === MarginTypes.MARGIN_NONE;
    }
    GetLeverages() {
        return this.Leverages;
    }
    GetLeverageTier(tier) {
        return this.Leverages[tier] || null;
    }
    IsLeverageVisible() {
        const coefMarginTypeSuit = this.IsPriceBasedMultipleCoefMarginType();
        const leverages = this.GetLeverages();
        const leveragesNotEmpty = leverages === null || leverages === void 0 ? void 0 : leverages.length;
        return !!(coefMarginTypeSuit && leveragesNotEmpty);
    }
    GetUseSettledCashForStocksForOpenedPositionsInMA() {
        return this.UseSettledCashForStocksForOpenedPositionsInMA;
    }
    GetUseSettledCollateralForOpenedPositionInMA() {
        return this.UseSettledCollateralForOpenedPositionInMA;
    }
    GetCurrencyId() {
        return this.CurrencyId;
    }
    getValue(literal) {
        return this[literal];
    }
}
